<template>
  <v-layout column id="filterMultiSelect">
    <span class="selected-area" v-if="value && value.length > 0">
      <v-chip class="selected-item" :class="{'with-avatar': item.color_id || item.photo_path}" v-for="item in value"
              outlined small
              :key="JSON.stringify(item)"
              @click="onChipClicked(item)">
        <BookingAvatar v-if="item.color_id || item.photo_path" :color-id="item.color_id" :photo-url="item.photo_path"/>
        <span class="chip-text">{{item[itemText]}}</span>
        <v-icon right size="8px">icon-close_new</v-icon>
      </v-chip>
    </span>
    <v-select ref="optionList"
              :value="value" :items="allItems"
              outlined dense hide-details multiple
              :item-text="itemText"
              :menu-props="{closeOnContentClick, nudgeTop: -40, top: true}"
              :disabled="disabled"
              attach="#filterMultiSelect">
      <template v-slot:selection="data">
        {{''}}
      </template>
      <template v-slot:label>
        <div class="text-field-label">{{hint}}</div>
      </template>
      <template v-slot:item="{ item }">
        <div class="list-item-wrapper" :class="{'select-all-item' : item[itemId] === -1 }"
              @click="onListItemClicked(item, !getIsSelected(item))">
          <v-checkbox v-if="checkbox" :input-value="getIsSelected(item)" class="list-item shrink mr-0 mt-0"
                      color="#3ac18f" hide-details :indeterminate="item[itemId] === -1 && isIndeterminate"/>
          <BookingAvatar v-if="item.color_id || item.photo_path" class="list-item"
                         :color-id="item.color_id" :photo-url="item.photo_path"/>
          <span class="chip-text list-item">{{ item[itemText]}}</span>
        </div>
      </template>
    </v-select>
  </v-layout>
</template>

<script>
  import BookingAvatar from "@/modules/bookings//components/common/bookingAvatar/BookingAvatar";

  export default {
    name: "FilterMultiselect",
    components: {BookingAvatar},
    props: {
      items: {
        type: Array,
        required: true,
      },
      itemText: {
        type: String,
        default: 'text'
      },
      itemId: {
        type: String,
        default: 'id',
      },
      hint: {
        type: String,
        default: '',
      },
      value: {
        type: Array,
        required: false,
      },
      checkbox: {
        type: Boolean,
        default: false,
      },
      showSelectAll: {
        type: Boolean,
        default: false,
      },
      selectAllLabel: {
        type: String,
        default: 'Select All'
      },
      closeOnContentClick: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      allItems() {
        if (this.showSelectAll) {
          const selectAllItem = {};
          selectAllItem[this.itemId] = -1;
          selectAllItem[this.itemText] = this.selectAllLabel;
          return [selectAllItem, ...this.items];
        }
        return this.items;
      },
      isAllSelected() {
        return this.showSelectAll && this.value && this.value.length === this.items.length;
      },
      isIndeterminate() {
        return this.showSelectAll && this.value && this.value.length > 0 && this.value.length < this.items.length;
      },
    },
    methods: {
      onChipClicked(data) {
        const newValue = [...this.value];
        const itemIndex = newValue.indexOf(data);
        if (itemIndex !== -1) {
          newValue.splice(itemIndex, 1);
          this.$emit('input', newValue);
        }
      },
      getIsSelected(data) {
        if (data[this.itemId] === -1) {
          return this.isAllSelected;
        }
        return this.value && !!this.value.find(item => item[this.itemId] === data[this.itemId]);
      },
      onListItemClicked(item, isSelected) {
        if (this.showSelectAll && item[this.itemId] === -1) {
          if (isSelected) {
            this.$emit('input', this.items);
          } else {
            this.$emit('input', []);
          }
        } else {
          // Remove the 'select all' item
          const newValue = this.value ? [...this.value] : [];
          isSelected ? newValue.push(item) : newValue.splice(newValue.indexOf(item), 1);
          this.$emit('input', newValue);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_i18n-mixins.scss";

  .selected-area {
    padding-bottom: 15px;

    .selected-item {
      margin-right: 8px;
      margin-top: 2px;

      .staff-avatar {

        .avatar-icon,
        img {
          border-radius: 35px;
          width: 18px;
          height: 18px;
        }
      }

      &.with-avatar {
        padding-left: 0;
      }
    }
  }

  .select-all-item {
    width: 100%;
    border-bottom: 1px solid #dadce0;
  }

  .list-item-wrapper {
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .list-item {
    display: inline-block;
    vertical-align: middle;
  }

  .chip-text {
    @include i-padding-mirror(5px, 0);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
  }

  .text-field-label {
    font-size: 14px;
  }
</style>
